var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutiveDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3942 9.91797C36.2811 9.91797 37 10.6301 37 11.5086V28.2571C37 29.1356 36.2811 29.8477 35.3942 29.8477H13.6058C12.7189 29.8477 12 29.1356 12 28.2571V11.5086C12 10.6301 12.7189 9.91797 13.6058 9.91797H35.3942ZM34.8587 12.0388H14.1411V27.7264H34.8587V12.0388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5478 29.1426V39.116H23.4067V29.1426H25.5478Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.507 38.166V40.2869H18.6941V38.166H30.507Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5971 6.71484V11.0134H23.4561V6.71484L25.5971 6.71484Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5299 16L25.6709 16.0167L25.5971 25.3191L23.4561 25.3025L23.5299 16Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4366 20.6816L31.5774 20.7153L31.5036 25.3284L29.3628 25.2947L29.4366 20.6816Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2298 18.3418L19.3708 18.3641L19.297 25.3219L17.156 25.2996L17.2298 18.3418Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveDashboard);
export default __webpack_public_path__ + "static/media/ExecutiveDashboard.3f61df2c042deaa32c492355d118f2fa.svg";
export { ForwardRef as ReactComponent };